import React from 'react';
import CONSTANT from './../../constant';

import Header from '../../component/common/Header';
import Paging from '../../component/common/Paging';
import TextEditor from '../../component/common/TextEditor';

import { getDateParts } from '../../utils';
import { getDraftList, deleteDraft,deleteDraftById } from './../../actions/eDraftAction';

class ComponentName extends React.Component<any, any>{
    _isMounted = false;
    constructor(props: any) {
        super(props);
        this.state = {
            page: 1,
            limit: 50,
            list: undefined,
            isLoading: true
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allFiles;

        this.loadList();
    }


    render() {
        const { page, list } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <h3 className="page-title">Draft(s)</h3>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {
                                                list === undefined &&  <div className="text-center">Loading.. </div>

                                            }
                                            {
                                                list !== undefined && list.length === 0 && <div className="text-center">No records found</div>
                                            }
                                            {
                                                list !== undefined && list.map((item: any, index: number) => {
                                                    const co = getDateParts(item.modifiedOn);
                                                    return (
                                                        <div className="card mb-3" key={index}>
                                                            <div className="card-header">
                                                                {`${co.date} ${co.monthName} ${co.year} ${co.hour}:${co.minute} ${co.amOrpm}`}
                                                                <a href="javascript:;" className="text-danger float-right" onClick={this.onDelete} data-id={item.id}>
                                                                    Delete
                                                                </a>
                                                            </div>
                                                            <div className="card-body">
                                                                <TextEditor
                                                                    value={item.content}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            list !== undefined && <Paging page={page} listItem={list} onPageChange={this.changePage} />
                        }
                    </div>
                </div>
            </div >
        )
    }

    loadList = () => {
        
        const { page, limit } = this.state;
        this._isMounted = true;              // note mutable flag
        getDraftList(page, limit).then((res: any) => {
            if(this._isMounted){
                this.setState({ list: res.result });
            }    
                  
        })
        
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }

    onDelete = (e: any) => {
        const isSure = window.confirm('Are you sure, you want to delete this?');
        if (isSure) {
            const id = parseInt(e.target.dataset.id, 10);
            deleteDraftById(id).then((res: any) => {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    window.location.reload();
                } else {
                    alert(res.error.message);
                }

            })
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
      }
}

export default ComponentName;